const initalState = {
  menuItems: []
};

function syncMenu(state = initalState, action) {
  switch (action.type) {
    case "LOAD_MENU":
      return {
        ...state,
        menuItems: action.menu
      };
    case "EXPAND_MENNU":
      state.menuItems[action.index] = {
        expanded: true,
        children: state.menuItems[action.index].children
      };
      return {
        ...state
      };
    case "COLLAPSE_MENU":
      state.menuItems[action.index] = {
        expanded: false,
        children: state.menuItems[action.index].children
      };
      return {
        ...state
      };
    case "COLLAPSE_ALL":
      var newstate = { ...state };
      Object.keys(state.menuItems).forEach((key, index) => {
        return (newstate.menuItems[key] = {
          expanded: false,
          children: state.menuItems[key].children
        });
      });
      return newstate;

    default:
      return state;
  }
}

export default syncMenu;
